import { Component } from '@angular/core';
import { NgxWavesurferService } from 'ngx-wavesurfer';

@Component({
  selector: 'app-ngx-wavesurfer-component-demo',
  templateUrl: './ngx-wavesurfer-component-demo.component.html',
  styleUrls: ['./ngx-wavesurfer-component-demo.component.scss'],
  providers: [NgxWavesurferService]
})
export class NgxWavesurferComponentDemoComponent {
  code = `import { Component, Input } from '@angular/core';
import { NgxWavesurferService } from 'ngx-wavesurfer';

@Component({
  selector: 'app-single-ngx-wavesurfer-component',
  template: '<ngx-wavesurfer [audioURL]="audioURL"
    (click)="waveSurferService.WaveSurfer.playPause()"></ngx-wavesurfer>
    <button class="btn btn-light" (click)="waveSurferService.WaveSurfer.playPause()">Play</button>',
  providers: [NgxWavesurferService]
})
export class NgxWavesurferSingleComponent {
  @Input() audioURL: string;
  constructor(public waveSurferService: NgxWavesurferService) {}
}`;
  constructor(public waveSurferService: NgxWavesurferService) {}
}
